import { memo } from "react";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Skeleton } from "@/components/ui/skeleton";
import { SuggestionCardMinimal } from "./SuggestionCardMinimal";
import type { FriendSuggestion } from "@/utils/friendSuggestions";

interface SuggestionsSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  suggestions: FriendSuggestion[];
  isLoading: boolean;
  onAddFriend: (userId: string) => void;
  isAdding: boolean;
}

export const SuggestionsSheet = memo(function SuggestionsSheet({
  open,
  onOpenChange,
  suggestions,
  isLoading,
  onAddFriend,
  isAdding,
}: SuggestionsSheetProps) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="bottom" className="h-[85vh] rounded-t-xl">
        <SheetHeader className="pb-4">
          <SheetTitle>People You May Know</SheetTitle>
        </SheetHeader>
        
        <ScrollArea className="h-[calc(85vh-80px)]">
          <div className="space-y-2 pr-4">
            {isLoading ? (
              Array.from({ length: 5 }).map((_, i) => (
                <Skeleton key={i} className="h-16 w-full" />
              ))
            ) : suggestions.length === 0 ? (
              <p className="text-center text-muted-foreground py-8">
                No suggestions available right now.
              </p>
            ) : (
              suggestions.map((suggestion) => (
                <SuggestionCardMinimal
                  key={suggestion.userId}
                  suggestion={suggestion}
                  onAddFriend={onAddFriend}
                  isAdding={isAdding}
                />
              ))
            )}
          </div>
        </ScrollArea>
      </SheetContent>
    </Sheet>
  );
});
